import axios from 'axios'
import { supabase } from './supabase'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
})

// Attach Supabase access token to every request
api.interceptors.request.use(
  async (config) => {
    const { data: { session } } = await supabase.auth.getSession()
    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// On 401, sign out and redirect to login
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await supabase.auth.signOut()
      window.location.href = '/login'
      return Promise.reject(error)
    }
    // Log all non-401 API errors with full detail
    const url    = error.config?.url || '(unknown)'
    const status = error.response?.status
    const body   = error.response?.data
    console.error(`[API] ${error.config?.method?.toUpperCase()} ${url} → ${status}`, body)
    return Promise.reject(error)
  }
)

export default api
